export const AUTH_LOCALE_ES = {
  AUTH: {
    FIELD: {
      EMAIL: 'Correo electrónico',
      PASSWORD: 'Contraseña',
      CONFIRM_PASSWORD: 'Confirmar contraseña',
      NEW_PASSWORD: 'Nueva contraseña',
    },
    LOGIN: {
      SUBTITLE: 'Entra con tu cuenta de IBSOA para gestionar reservas y clientes.',
      RESTRICTED:
        'Acceso solo para el personal de IBSOA. Si necesitas una cuenta, pídela al equipo de administración.',
      TITLE: 'Acceso al back office',
      FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
      FORGOT_PASSWORD_GO: 'Recupérala aquí',
    },
    FORGOT_PASSWORD: {
      TITLE: '¿Olvidó su contraseña?',
      SUBTITLE: 'Ingrese su correo electrónico para restablecer su contraseña.',
    },
    RESET_PASSWORD: {
      TITLE: 'Recuperar contraseña',
      CODE_LABEL: 'Código de verificación',
      CREATE_NEW_PASSWORD: 'Crea tu nueva contraseña',
      NEW_PASSWORD_SUBTITLE:
        'Define una nueva contraseña segura para continuar con el acceso.',
      CODE_REQUIRED:
        'Debe insertar el código de 8 caracteres enviado a su email.',
      INVALID_CODE: 'El código es inválido o ha caducado. Solicita uno nuevo.',
      TOO_MANY_ATTEMPTS:
        'Demasiados intentos. Espera un momento e inténtalo de nuevo.',
      TOKEN_EXPIRED:
        'Tu sesión de recuperación ha expirado. Solicita un nuevo código.',
      SUBTITLE:
        'Introduce el código y tu nueva contraseña para acceder a <b>{{ name }}</b>. Si no encuentras el código quizás esté en tu bandeja de spam.',
    },
  },
};
